import { Pipe, PipeTransform } from '@angular/core';
import { DurationInterface, DurationPeriod } from '@vendasta/sales-orders';

@Pipe({
  standalone: true,
  name: 'formatDuration',
})
export class FormatDurationPipe implements PipeTransform {
  transform(duration: DurationInterface): { value: number; period: string } {
    if (!duration) {
      return { value: 0, period: '' };
    }
    let period = 'month';
    if (duration.duration === DurationPeriod.YEAR) {
      period = 'year';
    }
    if (duration.value > 1) {
      period += 's';
    }
    return { value: duration.value, period: period };
  }
}
